export default "__VITE_ASSET__2c471c58__"